import { render } from "./AccueilMain.vue?vue&type=template&id=1c21f382"
import script from "./AccueilMain.vue?vue&type=script&lang=js"
export * from "./AccueilMain.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__